import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import styles from './CardTagsList.module.scss';

/**
 * 🏷️ CardTagsList - Componente para exibir tags dos cards
 * 
 * Features:
 * - Exibe até 4 tags
 * - Tooltip com tags adicionais
 * - Click para abrir modal de gerenciamento
 */

const CardTagsList = ({ tags = [], maxVisible = 4 }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  if (!tags || tags.length === 0) return null;
  
  const visibleTags = tags.slice(0, maxVisible);
  const hiddenTags = tags.slice(maxVisible);
  const hasMore = hiddenTags.length > 0;
  
  return (
    <div className={styles.tagsContainer}>
      {/* Tags visíveis */}
      {visibleTags.map(tag => (
        <span
          key={tag.id}
          className={styles.tag}
          style={{ backgroundColor: tag.color }}
          title={tag.name}
        >
          {tag.name}
        </span>
      ))}
      
      {/* Badge "+X mais" com tooltip */}
      {hasMore && (
        <div 
          className={styles.moreTagsContainer}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <span className={styles.moreTag}>
            +{hiddenTags.length}
          </span>
          
          {/* Tooltip com tags ocultas */}
          {showTooltip && (
            <div className={styles.tooltip}>
              <div className={styles.tooltipArrow} />
              <div className={styles.tooltipContent}>
                {hiddenTags.map(tag => (
                  <span
                    key={tag.id}
                    className={styles.tooltipTag}
                    style={{ backgroundColor: tag.color }}
                  >
                    {tag.name}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CardTagsList;
